import { isExistingUserExistingAccount } from '../app/verificationTypeSelectors';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { getIsAuthenticated } from '../store/auth/selectors';
import { isEndOfFlow } from '../store/flow/selectors';
import { hasPostSignupBeenSubmitted } from '../store/http-responses/selectors';
import { hasAnsweredAllPostExistingAccountSelectedQuestions } from '../store/signup-data/selectors';
export const canRedirectExistingUserExistingAccount = state => {
  const flowRedirectFunc = getFlowConfig().canRedirectExistingUserExistingAccount;
  const flowConfigRedirectCheck = flowRedirectFunc ? flowRedirectFunc(state) : true;
  return isEndOfFlow(state) && getIsAuthenticated(state) && hasPostSignupBeenSubmitted(state) && hasAnsweredAllPostExistingAccountSelectedQuestions(state) && isExistingUserExistingAccount(state) && flowConfigRedirectCheck;
};